import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { useNavigate } from 'react-router-dom';


const SupportCard = ({ title = "Support", svgIcon, redirect, isExternal = false }) => {
  const navigate = useNavigate();

  const renderSvg = (svgIcon) => (<img src={svgIcon} style={{ height: '100%' }} />);

  const renderContent = () => {
    return <>
      <Box sx={{ height: 50 }}>
        {renderSvg(svgIcon)}
      </Box>
      <div style={{ marginTop: 12 }}>
        <Typography component="div" fontWeight={700} fontSize={18}>
          {title}
        </Typography>
      </div>
    </>
  }

  const renderExternalLink = () => {
    return (
      <a href={redirect} target='_blank'
         style={{ height: '100%' }}>
        {renderContent()}
      </a>
    );
  }

  const renderInternalLink = () => {
    return (
      <button onClick={() => navigate(redirect)}
              style={{
                height: '100%',
                backgroundColor: 'transparent',
                border: 0,
                padding: 0,
                textAlign: 'left',
                cursor: 'pointer'
              }}
      >
        {renderContent()}
      </button>
    );
  }

  return (
    <Card
      sx={{
        width: 250,
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        boxShadow: '0px 1px 8px 0px #0000001F, 0px 3px 4px 0px #00000024, 0px 3px 3px -2px #00000033'
      }}>
      <CardContent sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', pl: 4, pt: 3, pb: 1 }}>
        {isExternal ? renderExternalLink() : renderInternalLink()}
      </CardContent>
    </Card >
  );
}

export default SupportCard;
